import { useLocalStorage } from '@vueuse/core'
import { defineStore } from 'pinia'

export const useDarkModeStore = defineStore('darkMode', () => {
  const darkMode = useLocalStorage('darkMode', false)
  function toggleDarkMode() {
    darkMode.value = !darkMode.value
  }
  function setDarkMode() {
    darkMode.value = false
  }
  function setLightMode() {
    darkMode.value = true
  }
  return { darkMode, toggleDarkMode, setLightMode, setDarkMode }
})
